import type { ProductionCalendarDate } from 'services/api';
import type { CalendarListData } from '../model';
import { Month } from '../../types';

const getMonthFromDate = (date: string): Month => {
  const monthIndex = new Date(date).getMonth();
  const months = [
    Month.JANUARY,
    Month.FEBRUARY,
    Month.MARCH,
    Month.APRIL,
    Month.MAY,
    Month.JUNE,
    Month.JULY,
    Month.AUGUST,
    Month.SEPTEMBER,
    Month.OCTOBER,
    Month.NOVEMBER,
    Month.DECEMBER,
  ];
  return months[monthIndex];
};

export const formatDate = (date: string): string => {
  const d = new Date(date);
  const day = d.getDate();
  const monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];

  return `${day} ${monthNames[d.getMonth()]}`;
};

const sortDates = (dates: ProductionCalendarDate[]): ProductionCalendarDate[] => {
  return dates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
};

export const transformCalendarDataToListData = (
  data: ProductionCalendarDate[],
): CalendarListData[] => {
  const state: CalendarListData[] = [
    {
      month: Month.SEPTEMBER,
      dates: [],
    },
    {
      month: Month.OCTOBER,
      dates: [],
    },
    {
      month: Month.NOVEMBER,
      dates: [],
    },
    {
      month: Month.DECEMBER,
      dates: [],
    },
    {
      month: Month.JANUARY,
      dates: [],
    },
    {
      month: Month.FEBRUARY,
      dates: [],
    },
    {
      month: Month.MARCH,
      dates: [],
    },
    {
      month: Month.APRIL,
      dates: [],
    },
    {
      month: Month.MAY,
      dates: [],
    },
  ];

  if (!data.length) {
    return [];
  }

  sortDates(data).forEach((item) => {
    const month = getMonthFromDate(item.date);
    const monthIndex = state.findIndex((m) => m.month === month);
    if (monthIndex !== -1) {
      state[monthIndex].dates.push({
        date: item.date, // Сохраняем исходную дату в формате YYYY-MM-DD
        holiday: item.holiday,
        description: item.description,
        id: item.id,
      });
    }
  });

  return state;
};
